import React from 'react';
import { Image, Space } from 'antd';

/**
 * Hiển thị danh sách ảnh, hỗ trợ xem trước nhiều ảnh với Image.PreviewGroup
 *
 * @param {Array} images - Mảng ảnh [{ url | src }]
 * @param {number} width - Chiều rộng ảnh (default: 100)
 * @param {number} height - Chiều cao ảnh (default: 100)
 * @param {string} fallbackText - Text nếu không có ảnh
 * @param {'horizontal' | 'vertical'} direction - Chiều hiển thị ảnh
 */
const ImageListDisplay = ({
    images = [],
    width = 100,
    height = 100,
    fallbackText = 'Không có ảnh',
    direction = 'horizontal',
}) => {
    if (!Array.isArray(images) || images.length === 0) {
        return <span>{fallbackText}</span>;
    }

    return (
        <Image.PreviewGroup>
            <Space size={8} wrap direction={direction}>
                {images.map((item, index) => {
                    const src = item?.url || item?.src;
                    if (!src) return null;

                    return (
                        <Image
                            key={index}
                            src={src}
                            alt={`Ảnh ${index + 1}`}
                            width={width}
                            height={height}
                            style={{ objectFit: 'cover' }}
                        />
                    );
                })}
            </Space>
        </Image.PreviewGroup>
    );
};

export default ImageListDisplay;
